module.exports = __webpack_public_path__ + "img/logo.26ee584d.png";